import * as React from 'react';
import { Flex, InfoIcon, SiteVariablesPrepared } from "@fluentui/react-northstar";

export function ChartEmptyState({
  siteVariables,
}: {
  siteVariables: SiteVariablesPrepared;
}) {
  const textColor = siteVariables.colors.grey["400"];
  const { t } = siteVariables;
  return (
    <Flex
      styles={{
        height: "100%",
        minHeight: "14rem",
        backgroundColor: siteVariables.colorScheme.grey.background,
        color: textColor,
      }}
      vAlign="center"
      hAlign="center"
    >
      <InfoIcon outline styles={{ marginRight: ".5rem" }} /> {t["no data"]}
    </Flex>
  );
}
